function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#A1A8C3",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.707 14.293a1 1 0 0 1-1.414 1.414l-3.733-3.733a1 1 0 1 1 1.414-1.414l3.733 3.733z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 14A7 7 0 1 1 7 0a7 7 0 0 1 0 14zm0-2A5 5 0 1 0 7 2a5 5 0 0 0 0 10z"
}));

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _ref);

export default __webpack_public_path__ + "static/media/search-small.17894bb3.svg";
export { SvgComponent as ReactComponent };